import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_role } from '../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_GRID2D__view } from '../../_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION_IMAGE__viewport } from '../../_invocations/image/INVOCATION_IMAGE__viewport';
import { INVOCATION_VISION_ML__depth_anything } from '../../_invocations/vision/depth/INVOCATION_VISION_ML__depth_anything';
import { DECORATOR__generation_tool_ml_asset_requirement } from '../_decorators/DECORATOR__generation_tool_ml_asset_requirement';
import { ENUM__graph_template_name } from '../sd_1/ENUM__graph_template_name';

export class GENERATION_TOOL__vision_depth {
  @DECORATOR__generation_tool_ml_asset_requirement(ENUM__ml_asset_family.VISION_DEPTH_ANYTHING, ENUM__ml_asset_type.VISION)
  static create() {
    let out = new DTO__generation_tool();
    out.name = ENUM__graph_template_name.CREATE_DEPTH;

    const graph = new DTO_GRAPH__instance();
    out.graph = graph;

    graph.create_meta();
    graph.meta.graph_id = ENUM__string_id_empty.OBJECT_ID;

    /*
     * GRID2D
     */
    const node__grid2d = INVOCATION_GRID2D__view.create_node_for(graph);

    /*
     * VIEWPORT
     */

    const node__crop_and_mask = INVOCATION_IMAGE__viewport.create_node_for(graph, ENUM__invocation_role.CORE__IMAGE_VIEWPORT);

    /*
     *
     */

    const node__depth_anything = INVOCATION_VISION_ML__depth_anything.create_node_for(graph);
    graph.edge__try_add_for_fields(node__depth_anything.out, node__grid2d.image);
    graph.edge__try_add_for_fields(node__crop_and_mask.out__image_cropped, node__depth_anything.image);

    /*
     *
     */

    /*
     * INPUTS
     */

    /*
     * VIEWS
     */
    let fields__visible: FIELD__base[] = [node__crop_and_mask.image, node__depth_anything.model];
    let field_column_id = node__depth_anything.model.meta.field_id;
    out.view__add({ fields__visible, fields__stored: fields__visible, field_column_id });

    /*
     *
     */

    return out;
  }
}
